import axios from "axios";
export let API_URL = "";

export const ApiHelperFunction = async (data) => {
  const knighthuntToken = localStorage.getItem("knighthunt-token");
  console.log(window.location.href, "window.location.href");
  // API_URL = "http://localhost:8000/api/v1/";
  API_URL = "https://dev-api.knighthunt.com/api/v1";

  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // API_URL = "http://localhost:8000/api/v1";
    API_URL = "https://dev-api.knighthunt.com/api/v1";
  } else {
    API_URL = "https://dev-api.knighthunt.com/api/v1";
  }

  const { urlPath, method, formData } = data;
  const config = {
    method: `${method}`,
    withCredentials: true,
    url: `${API_URL}${urlPath}`,
    data: formData,
    headers: {
      Authorization: "Bearer " + knighthuntToken,
      Accept: "application/json",
    },
  };
  let responseData = "";
  await axios(config)
    .then((response) => {
      responseData = response;
    })
    .catch((error) => {
      responseData = { ...error, ...error?.response };
    });

  if (responseData?.response?.data?.additional?.alive?.toString() === "false") {
    ApiHelperFunction({
      urlPath: "auth/logout",
      method: "GET",
    }).then((res) => {
      localStorage.removeItem("knighthunt-token");
      window.location.href = "/";
    });
  }
  return responseData;
};
